export enum IvrMenuType {
  IvrMenu = 0
}

export interface IIvrCustomMenuRepository {
  getMenuList();
}
